module.exports = __webpack_public_path__ + "img/micon.5e43ff6.webp";